import React, { Component, createRef } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: inline-block;
  position: relative;
`;

const MeasuringSpan = styled.span`
  position: absolute;
  visibility: hidden;
  white-space: pre;
  font: inherit;
  padding: 0;
  cursor: pointer;
`;

const StyledInput = styled.input`
  border: none;
  background: transparent;
  outline: none;
  font: inherit;
  color: inherit;
  width: ${props => props.$width}px;
  cursor: pointer;
`;

class AutoSizeInput extends Component {
  constructor(props) {
    super(props);
    this.spanRef = createRef();
    this.inputRef = createRef();
    this.state = {
      value: props.initialValue || "",
      inputWidth: 1,
      isEditing: false,
      firstBlurHappened: false
    };
  }

  componentDidMount() {
    this.updateWidth();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.initialValue !== this.props.initialValue || prevState.value !== this.state.value) {
      this.updateWidth();
    }

    if (!prevProps.isEditing && this.props.isEditing) {
      this.inputRef.current.focus();
      this.inputRef.current.select();
    }

    if (prevProps.isEditing && !this.props.isEditing) {
      // finished editing
      this.setState({ firstBlurHappened: false });
    }

    if (!this.props.isEditing && prevProps.initialValue !== this.props.initialValue) {
      this.setState({ value: this.props.initialValue });
    }
  }

  updateWidth = () => {
    if (this.spanRef.current) {
      const width = this.spanRef.current.offsetWidth;
      this.setState({ inputWidth: Math.max(width + 2, 30) }); // add small buffer
    }
  };

  handleChange = e => {
    this.setState({ value: e.target.value });
  };

  handleBlur = e => {
    if (!this.props.isEditing) return;
    if (!this.state.firstBlurHappened) {
      this.setState({ firstBlurHappened: true });
      this.inputRef.current.focus();
      this.inputRef.current.select();
      return;
    }
    if (this.props.onCommit) {
      this.props.onCommit(this.state.value);
    }
  };

  render() {
    const { className, isEditing, onCommit, ...rest } = this.props;
    const { value, inputWidth } = this.state;

    return (
      <Wrapper className={className}>
        <MeasuringSpan ref={this.spanRef}>{value || " "}</MeasuringSpan>
        <StyledInput
          ref={this.inputRef}
          value={value}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          readOnly={!isEditing}
          $width={inputWidth}
          {...rest}
        />
      </Wrapper>
    );
  }
}

export default AutoSizeInput;
